import type { ScaleDegree } from '../uTheory.Interaction/solfegeDefinitions';

export const one = `
key:CM meter:2/4
clef:treble C/e D/e:v0.4 C/e:v0.45 B3/e:v0.3 | C/h:v0.25 |||
clef:bass D3-F3-A3/q:v0.2 G2-F3-G3/q:v0.17 | C3-E3-G3/h:v0.1 |||
`;

export const oneBass = `
key:CM meter:2/4
clef:bass D4-F4-A4/q:v0.2 G3-F4-G4/q:v0.17 | C4-E4-G4/h:v0.1 |||
clef:bass C3/e D3/e:v0.4 C3/e:v0.45 B2/e:v0.3 | C3/h:v0.25 |||
`;

export const two = `
key:CM meter:2/4
clef:treble D/h | C/h:v0.25 |||
clef:bass D3/h:v0.25 | E3/h:v0.12 |||
clef:bass F2-A3/q:v0.25 G2-B3/q:v0.2 | C3-E3-G3/h:v0.12 |||
`;

export const twoBass = `
key:CM meter:2/4
clef:treble A4/q:v0.20 B4/q:v0.16 | C5-G4/h:v0.12 |||
clef:treble D4-F4/h:v0.18 | E4/h:v0.12 |||
clef:bass D3/h | C3/h:v0.25 |||
`;

export const three = `
key:CM meter:2/4
clef:treble E/q.:v0.5 D/e:v0.4 | C/h:v0.3 |||
clef:bass r/q G2-F3-B3/q:v0.25 | C3-E3-G3/h:v0.15 |||
`;

export const threeBass = `
key:CM meter:2/4
clef:treble r/q G4-F4-B4/q:v0.15 | C5-E4-G4/h:v0.10 |||
clef:bass E3/q.:v0.7 D3/e:v0.6 | C3/h:v0.5 |||
`;

export const four = `
key:CM meter:2/4
clef:treble F/q:v0.5 E/e:v0.5 D/e:v0.4 | C/h:v0.3 |||
clef:bass F2-D3-A3/q:v0.25 G2-D3-B3/q:v0.15 | C3-E3-G3/h:v0.1 |||
`;

export const fourBass = `
key:CM meter:2/4
clef:treble D-B/q:v0.20 C-C5/e:v0.15 B3-D5/e:v0.17 | C-E5/h:v0.1 |||
clef:treble G/h:v0.20 | G/h:v0.1 |||
clef:bass F3/q:v0.7 E3/e:v0.5 D3/e:v0.6 | C3/h:v0.3 |||
`;

export const five = `
key:CM meter:2/4
clef:treble G/q:v0.6 [F/e:v0.5 E/e:v0.4 D/e:v0.3] | C/h:v0.2 |||
clef:treble C/q:v0.2 B3/q:v0.17 | G3/h:v0.1 |||
clef:bass G3/h:v0.2 | E3/h:v0.1 |||
clef:bass E2/e:v0.2 F2/e:v0.23 G2/q:v0.26 | C3/h:v0.1 |||
`;

export const fiveBass = `
key:CM meter:2/4
clef:treble G5/q:v0.2 G5/q:v0.17 | G5/h:v0.1 |||
clef:treble E5/q:v0.17 D5/q:v0.15 | E5/h:v0.1 |||
clef:treble C5/q:v0.1 B/q:v0.1 | C5/h:v0.1 |||
clef:bass G3/q:v0.6 [F3/e:v0.5 E3/e:v0.4 D3/e:v0.3] | C3/h:v0.2 |||
`;

export const six = `
key:CM meter:2/4
clef:treble A4/q:v0.6 [G4/e:v0.50 A/e:v0.55 B/e:v0.45] | C5/h:v0.25 |||
clef:treble D4/h:v0.15                | E4/h:v0.1 |||
clef:treble C/q:v0.15   B3/q:v0.2          | G3/h:v0.1 |||
clef:bass   F3/q:v0.15  G3/q:v0.2          | C3/h:v0.1 |||
`;

export const sixBass = `
key:CM meter:2/4
clef:treble   F5/h:v0.2            | E5/h:v0.15 |||
clef:treble D5/h:v0.15                | C5/h:v0.1 |||
clef:treble C5/q:v0.15   B/q:v0.2          | G/h:v0.1 |||
clef:bass A3/q:v0.6 [G3/e:v0.50 A3/e:v0.55 B3/e:v0.45] | C/h:v0.25 |||
`;

export const seven = `
key:CM meter:2/4
clef:treble B/h:v0.6 | C5/h:v0.25 |||
clef:bass r/q G2-F3-D4/q:v0.17 | C3-E3-C4/h:v0.07 |||
`;

export const sevenBass = `
key:CM meter:2/4
clef:treble r/q G-F5-D6/q:v0.17 | G-E5-C6/h:v0.07 |||
clef:bass B3/h:v0.6 | C/h:v0.25 |||
`;

export const oneMinor = `
key:Cm meter:2/4
clef:treble C/e D/e:v0.4 C/e:v0.45 B3/e:v0.3 | C/h:v0.25 |||
clef:bass D3-F3-Ab3/q:v0.25 G2-F3-G3/q:v0.2 | C3-Eb3-G3/h:v0.15 |||
`;

export const oneMinorBass = `
key:Cm meter:2/4
clef:treble Ab4/q:v0.2 G4/q:v0.17 | G4/h:v0.1 |||
clef:treble D4-F4/h:v0.2  | C4-Eb4/h:v0.1 |||
clef:bass C3/e D3/e:v0.5 C3/e:v0.45 B2/e:v0.3 | C3/h:v0.25 |||
`;

export const twoMinor = `
key:Cm meter:2/4
clef:treble D/h | C/h:v0.3 |||
clef:bass D3/h:v0.25 | Eb3/h:v0.15 |||
clef:bass F2-Ab3/q:v0.25 G2-B3/q:v0.2 | C3-G3/h:v0.15 |||
`;

export const twoMinorBass = `
key:Cm meter:2/4
clef:treble C5-Ab/q:v0.20 B4-G/q:v0.16 | C5-G4/h:v0.12 |||
clef:treble F4/h:v0.18 | Eb4/h:v0.12 |||
clef:bass D3/h | C3/h:v0.25 |||
`;

export const threeMinor = `
key:Cm meter:2/4
clef:treble Eb/q.:v0.5 D/e:v0.4 | C/h:v0.3 |||
clef:bass r/q G2-F3-B3/q:v0.25 | C3-Eb3-G3/h:v0.15 |||
`;

export const threeMinorBass = `
key:Cm meter:2/4
clef:treble r/q G4-F4-B4/q:v0.15 | C5-Eb4-G4/h:v0.10 |||
clef:bass Eb3/q.:v0.7 D3/e:v0.6 | C3/h:v0.5 |||
`;

export const fourMinor = `
key:Cm meter:2/4
clef:treble F/q:v0.5 Eb/e:v0.5 D/e:v0.4 | C/h:v0.3 |||
clef:bass D3-Ab3-C/q:v0.2 G2-F3-B3/q:v0.15 | C3-Eb3-G3/h:v0.1 |||
`;

export const fourMinorBass = `
key:Cm meter:2/4
clef:treble D-B/q:v0.20 C-C5/e:v0.15 B3-D5/e:v0.17 | C-Eb5/h:v0.1 |||
clef:treble Ab/q:v0.20 G/q:v0.15 | G/h:v0.1 |||
clef:bass F3/q:v0.7 Eb3/e:v0.5 D3/e:v0.6 | C3/h:v0.3 |||
`;

export const fiveMinor = `
key:Cm meter:2/4
clef:treble G/q:v0.5 [F/e:v0.5 Eb/e:v0.4 D/e:v0.3] | C/h:v0.2 |||
clef:treble C/q:v0.2 B3/q:v0.17 | G3/h:v0.1 |||
clef:bass G3/h:v0.2 | Eb3/h:v0.1 |||
clef:bass Eb2/e:v0.2 F2/e:v0.25 G2/q:v0.28 | C3/h:v0.1 |||
`;

export const fiveMinorBass = `
key:Cm meter:2/4
clef:treble G5/q:v0.2 G5/q:v0.17 | G5/h:v0.1 |||
clef:treble Eb5/q:v0.17 D5/q:v0.15 | Eb5/h:v0.1 |||
clef:treble C5/q:v0.1 B/q:v0.1 | C5/h:v0.1 |||
clef:bass G3/q:v0.6 [F3/e:v0.5 Eb3/e:v0.4 D3/e:v0.3] | C3/h:v0.2 |||
`;

export const sixMinor = `
key:Cm meter:2/4
clef:treble Ab4/q:v0.45 [G4/e:v0.40 A/e:v0.45 B/e:v0.35] | C5/h:v0.25 |||
clef:treble D4/h:v0.15                | Eb4/h:v0.1 |||
clef:treble C/q:v0.15   B3/q:v0.2          | G3/h:v0.1 |||
clef:bass   F3/q:v0.15  G3/q:v0.2          | C3/h:v0.1 |||
`;

export const sixMinorBass = `
key:Cm meter:2/4
clef:treble   F5/h:v0.2            | Eb5/h:v0.15 |||
clef:treble D5/h:v0.15                | C5/h:v0.1 |||
clef:treble C5/q:v0.15   B/q:v0.2          | G/h:v0.1 |||
clef:bass Ab3/q:v0.6 [G3/e:v0.50 A3/e:v0.55 B3/e:v0.45] | C/h:v0.25 |||
`;

export const raisedSixMinor = `
key:Cm meter:2/4
clef:treble A/e:v0.35 B/e:v0.4 C5/e:v0.45 B/e:v0.35 | C5/h:v0.25 |||
clef:treble F/q:v0.2 Eb/e:v0.25 D/e:v0.22 | Eb/h:v0.1 |||
clef:bass D3-C/q:v0.17 G2-B3/q:v0.15 | C3-G3/h:v0.1 |||
`;

export const raisedSixMinorBass = `
key:Cm meter:2/4
clef:treble C5/e:v0.1 D5/e:v0.15 Eb5/e:v0.2 F5/e:v0.25 | G5/h:v0.3 ||
clef:treble F/q:v0.2 G/q:v0.15 | C5/h:v0.1
clef:treble F/q:v0.2 Eb/e:v0.2 D/e:v0.15 | Eb/h:v0.1 |||
clef:bass A3/e:v0.6 B3/e:v0.55 C/e:v0.65 B3/e:v0.45 | C/h:v0.25 |||
`;

export const sevenMinor = `
key:Cm meter:2/4
clef:treble Bb/e:v0.6 Ab/e:v0.55 [G/e:v0.5 A/e:v0.4 B/e:v0.3] | C5/h:v0.2 |||
clef:treble G4/e:v0.2 F4/e:v0.17 Eb4/e:v0.14 D4/e:v0.12 | Eb4/h:v0.1 |||
clef:treble Bb3/q:v0.2 B3/q:v0.17 | C/h:v0.15 |||
clef:bass Eb2/e:v0.2 F2/e:v0.25 G2/q:v0.28 | C3/h:v0.15 |||
`;

export const sevenMinorBass = `
key:Cm meter:2/4
clef:treble E5/e:v0.15 F5/e:v0.17 G5/e:v0.2 F5/e:v0.15 | Eb5/h:v0.1 |||
clef:treble C5/q:v0.15  D5/q:v0.17      | C5/h:v0.1 |||
clef:treble C5/q:v0.15   B/q:v0.2          | G/h:v0.1 |||
clef:bass Bb3/e:v0.7 Ab3/e:v0.6 [G3/e:v0.50 A3/e:v0.55 B3/e:v0.45] | C/h:v0.25 |||
`;

export const raisedSevenMinor = `
key:Cm meter:2/4
clef:treble B/h:v0.6 | C5/h:v0.25 |||
clef:bass r/q G2-Ab3-F4/q:v0.17 | C3-G3-Eb4/h:v0.07 |||
`;

export const raisedSevenMinorBass = `
key:Cm meter:2/4
clef:treble r/q Ab-F5-D6/q:v0.17 | G-Eb5-C6/h:v0.07 |||
clef:bass B3/h:v0.6 | C/h:v0.25 |||
`;

/**
 * Music-string resolution patterns in C Major/minor for each degree
 */
export const resolutionPatterns: {
  Major: Record<ScaleDegree, string>;
  minor: Record<ScaleDegree, string>;
  MajorBass: Record<ScaleDegree, string>;
  minorBass: Record<ScaleDegree, string>;
} = {
  Major: {
    1: one,
    2: two,
    3: three,
    4: four,
    5: five,
    6: six,
    M6: six,
    7: seven,
    M7: seven,
    8: one,
  },
  MajorBass: {
    1: oneBass,
    2: twoBass,
    3: threeBass,
    4: fourBass,
    5: fiveBass,
    6: sixBass,
    M6: sixBass,
    7: sevenBass,
    M7: sevenBass,
    8: oneBass,
  },
  minor: {
    1: oneMinor,
    2: twoMinor,
    3: threeMinor,
    4: fourMinor,
    5: fiveMinor,
    6: sixMinor,
    M6: raisedSixMinor,
    7: sevenMinor,
    M7: raisedSevenMinor,
    8: oneMinor,
  },
  minorBass: {
    1: oneMinorBass,
    2: twoMinorBass,
    3: threeMinorBass,
    4: fourMinorBass,
    5: fiveMinorBass,
    6: sixMinorBass,
    M6: raisedSixMinorBass,
    7: sevenMinorBass,
    M7: raisedSevenMinorBass,
    8: oneMinorBass,
  },
};
